import { React, useState, useEffect, useRef, useCallback } from "react";
import Nav from "./components/Nav/Nav";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Education from "./components/Education/Education";
import Skills from "./components/Skills/Skills";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import { Route, Routes } from "react-router-dom";
import SuccessPartners from "./components/Success_Partners/Success_Partners";
import DetalisProject from "./components/Detalis_Project/DetalisProject";
import Blog from "./components/Blog/Blog";
import Services from "./components/Services/Services";

function App() {
  const [trueDark, settrueDark] = useState(false);
  const [scale, setscale] = useState(1);
  const [isMobile, setIsMobile] = useState(false);
  const appRef = useRef(null); // ← إنشاء ref

  // كشف حجم الشاشة
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const setTrueDarkMode = (e) => {
    settrueDark(e);
  };

  // تحسين zoom ليكون أكثر ملاءمة للجوال
  const handlewheel = useCallback(
    (e) => {
      if (isMobile) return; // تعطيل zoom على الجوال

      e.preventDefault();
      const newScale = scale + e.deltaY * -0.001;
      setscale(Math.max(0.1, Math.min(newScale, 1)));
    },
    [isMobile, scale]
  );

  // ✅ إضافة الحدث يدويًا مع passive: false
  useEffect(() => {
    const appElement = appRef.current;
    if (appElement) {
      appElement.addEventListener("wheel", handlewheel, { passive: false });
    }

    return () => {
      if (appElement) {
        appElement.removeEventListener("wheel", handlewheel);
      }
    };
  }, [handlewheel]); // تأكد من تضمين التبعيات

  return (
    <div
      className={`App ${isMobile ? "mobile" : "desktop"}`}
      // onWheel={handlewheel}
    >
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Nav setTrueDarkMode={setTrueDarkMode} isMobile={isMobile} />
              <Home scale={scale} isMobile={isMobile} />
              <About trueDark={trueDark} isMobile={isMobile} />
              <Education isMobile={isMobile} />
              <Skills isMobile={isMobile} />
              <Blog isMobile={isMobile} />
              <Services isMobile={isMobile} />
              {/* <Portofilo isMobile={isMobile} /> */}
              {/* <div className="Company_Profile">
                <div className="Profile_Container">
                  <div className="Box">
                    <iframe
                      allowFullScreen
                      scrolling="no"
                      className="fp-iframe no_media"
                      src="https://heyzine.com/flip-book/4ed8fbe798.html"
                      style={{
                        border: "0px",
                        width: "100%",
                        height: isMobile ? "400px" : "600px",
                        objectFit: "cover",
                      }}
                    ></iframe>
                    <iframe
                      allowFullScreen
                      scrolling="no"
                      className="fp-iframe media"
                      src="https://heyzine.com/flip-book/bbb010d7fc.html"
                      style={{ 
                        border: "0px", 
                        width: "100%", 
                        height: isMobile ? "300px" : "400px" 
                      }}
                    ></iframe>
                  </div>
                  <div className="youtube">
                    <ReactPlayer 
                      url="https://www.youtube.com/watch?v=sKr5KucIptE" 
                      width={isMobile ? "100%" : "90%"}
                      height={isMobile ? "250px" : "500px"}
                    />
                  </div>
                </div>
              </div> */}
              <SuccessPartners isMobile={isMobile} />
              <Contact isMobile={isMobile} />
              <Footer isMobile={isMobile} />
            </>
          }
        ></Route>
      </Routes>
      <Routes>
        <Route
          path="/detalis"
          element={<DetalisProject isMobile={isMobile} />}
        ></Route>
      </Routes>
    </div>
  );
}

export default App;
